/* emoji-picker-loader — tiny stub that lazy-loads emoji-picker.js on first interaction.
 *
 * Triggers:
 *   - Click on any [data-emoji-picker] element (button) anywhere on the page
 *   - Focus on any [data-emoji-picker-target] input/textarea (preloads the picker
 *     so its first click feels instant)
 *
 * After the main module loads, this stub stays out of the way: window.EmojiPicker
 * takes over event handling.
 *
 * Why a separate file: ships on every page (~600 bytes gzipped after Vite
 * minify), so caching is worth one extra HTTP request. The real picker is
 * fetched only when a user actually wants to insert an emoji.
 */
(function(){
    'use strict';
    if (window.EmojiPicker || window.__EMOJI_PICKER_LOADING) return;

    var loaded = false;
    var loading = false;
    var queue = []; // {action: 'open', el}

    function load(){
        if (loaded || loading) return;
        loading = true;
        window.__EMOJI_PICKER_LOADING = true;
        var s = document.createElement('script');
        /* Versioned, because nginx serves /js/*.js `immutable` for 180 days and a
           script inserted by JS never passes through @light(). Without this the
           2026-08-31 fix that finally let Ukrainian emoji keywords load would
           have reached only people who had never opened a picker before. */
        var _src = window.__EMOJI_PICKER_SRC || '/js/emoji-picker.js';
        s.src = (typeof window.__jsSrc === 'function') ? window.__jsSrc(_src) : _src;
        s.async = true;
        s.onload = function(){
            loaded = true;
            loading = false;
            window.__EMOJI_PICKER_LOADING = false;
            // Drain queue: replay pending opens via the real picker.
            if (window.EmojiPicker && typeof window.EmojiPicker.openFor === 'function'){
                queue.splice(0).forEach(function(item){
                    try { window.EmojiPicker.openFor(item.el, item.opts || {}); } catch(_) {}
                });
            }
        };
        s.onerror = function(){
            loading = false;
            window.__EMOJI_PICKER_LOADING = false;
            /* Сюда доходит уже ИТОГ: первый обрыв повторила дверь layout'а (docs/why/primitives/lazy-script-door.md).
               Человек нажал кнопку эмодзи и ждёт — сказать ему, а не только консоли; следующее нажатие пробует снова, и ждавшие
               открытия не всплывают потом разом. */
            if (queue.length) {
                queue.length = 0;
                var T = window.__EMOJI_PICKER_T || {};
                try { if (T.error && window.__toast) window.__toast(T.error, 'error'); } catch (_) {}
            }
            console.warn('[emoji-picker] load failed');
        };
        document.head.appendChild(s);
    }

    function pickerButton(target){
        return target && target.closest && target.closest('[data-emoji-picker]');
    }
    function pickerTarget(target){
        return target && target.closest && target.closest('[data-emoji-picker-target]');
    }

    document.addEventListener('click', function(e){
        var btn = pickerButton(e.target);
        if (!btn) return;
        e.preventDefault();
        var opts = {
            targetId: btn.getAttribute('data-emoji-picker') || '',
            source:   btn.getAttribute('data-emoji-source') || 'unknown',
        };
        if (loaded && window.EmojiPicker){
            window.EmojiPicker.openFor(btn, opts);
        } else {
            queue.push({ el: btn, opts: opts });
            load();
        }
    }, false);

    // Focus on a target input → preload picker so the button click is snappy.
    document.addEventListener('focusin', function(e){
        if (loaded || loading) return;
        if (pickerTarget(e.target)) load();
    }, true);

    // Idle preload: 4 s after page is idle, prefetch on data-savvy connections.
    if ('requestIdleCallback' in window){
        var conn = navigator.connection || {};
        var saveData = !!conn.saveData;
        var slow = /^(slow-2g|2g)$/.test(conn.effectiveType || '');
        if (!saveData && !slow){
            requestIdleCallback(function(){
                if (!loaded && !loading && document.querySelector('[data-emoji-picker]')) load();
            }, { timeout: 4000 });
        }
    }

    // Public API surface for early callers.
    window.EmojiPicker = window.EmojiPicker || {
        _stub: true,
        openFor: function(el, opts){ queue.push({ el: el, opts: opts || {} }); load(); },
        attach: function(input, opts){ queue.push({ el: input, opts: Object.assign({ attach: true }, opts || {}) }); load(); },
    };
})();
